import baseFetch, { createParamString } from 'common/baseFetch';
import type { Camera } from 'types/camera';
import type { ForecastConditions, ForecastWaveHeight, ForecastWind, SwellPoint } from 'types/spot';

export interface SpotRecommendation {
  _id: string;
  name: string;
  rank: number;
  lat: number;
  lon: number;
  subregionId: string;
  cameras: Array<Camera>;
  conditions: ForecastConditions | null;
  waveHeight: ForecastWaveHeight;
  wind: ForecastWind;
  swells: Array<SwellPoint>;
  relivableRating: number | null;
  abilityLevels: Array<string>;
  hasLiveWind: boolean;
  timezone?: string;
}

export interface SpotRecommendationsResponse {
  recommendations: Array<SpotRecommendation>;
}

interface FetchSpotRecommendationsParams {
  lat: number;
  lon: number;
  subregionId?: string;
  offset: number;
  limit: number;
}

export const fetchSpotRecommendations = ({
  lat,
  lon,
  subregionId,
  offset,
  limit,
}: FetchSpotRecommendationsParams): Promise<SpotRecommendationsResponse> => {
  const paramString = createParamString({ lat, lon, subregionId, offset, limit });
  return baseFetch<SpotRecommendationsResponse>(`/kbyg/spots/recommendations?${paramString}`);
};

export const postSpotRecommendationsSeen = (spotIds: Array<string>): Promise<void> =>
  baseFetch('/kbyg/spots/recommendations/seen', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ spotIds }),
  });
